import { useScrollReveal } from "../../../hooks/useScrollReveal";

const BLOCKS = [
  {
    tag: "01 — Who We Help",
    title: "Homeowners & Businesses Across NJ, NY, PA & CT",
    body: "The Drapery & Blind Co. serves residential homeowners, luxury estates, commercial properties, interior designers, and property managers throughout New Jersey, New York, Pennsylvania, and Connecticut — bringing professional white-glove window treatment care directly to your door.",
    icon: "ri-home-heart-line",
  },
  {
    tag: "02 — What We Do",
    title: "Full-Service Window Treatment Cleaning & Restoration",
    body: "We professionally clean draperies, blinds, carpets, luminettes, silhouettes, and chandeliers. We also handle upholstery, area rugs, bedding, and leather restoration. Every item is taken down, cleaned at our professional facility, and rehung to perfection.",
    icon: "ri-service-line",
  },
  {
    tag: "03 — Key Benefits",
    title: "White-Glove Convenience with Zero Compromise",
    body: null,
    listItems: [
      "Free professional pickup & delivery — no trip charge",
      "Child-safe, pet-safe, odor-free eco-friendly solutions",
      "Fully insured with liability & workers' compensation",
      "Temporary shades installed at no cost while we clean",
      "Open 24 / 7 including emergency water & fire damage",
      "Accurate free estimates — no one-price-fits-all",
    ],
    icon: "ri-shield-star-line",
  },
  {
    tag: "04 — Our Process",
    title: "Taken Down, Restored, Returned & Rehung",
    body: "Our trained team arrives at your home or business, carefully takes down every window treatment, and transports them to our professional facility. There, each item is inspected, cleaned thoroughly on both sides, steamed, and pinned to perfection — then returned and rehung at your convenience.",
    icon: "ri-refresh-line",
  },
  {
    tag: "05 — Coverage",
    title: "Serving 40+ Cities — or Ship Us Your Items",
    body: "We cover all of New Jersey, New York, Pennsylvania, and Connecticut. If you're outside our service area, simply ship your window treatments to our Belleville, NJ facility — we'll clean and return them to you, perfectly restored.",
    icon: "ri-map-pin-line",
  },
];

export default function AIAnswerBlock() {
  const ref = useScrollReveal();

  return (
    <section className="py-24 bg-stone-950 relative overflow-hidden" ref={ref}>
      {/* Subtle diamond texture */}
      <div
        className="absolute inset-0 opacity-[0.03] pointer-events-none"
        style={{
          backgroundImage:
            "repeating-linear-gradient(45deg, #c8a96e 0, #c8a96e 1px, transparent 0, transparent 50%)",
          backgroundSize: "14px 14px",
        }}
      />

      <div className="relative z-10 max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="reveal text-center mb-16">
          <p className="text-amber-500 text-xs tracking-[0.35em] uppercase font-semibold mb-4">
            Complete Overview
          </p>
          <h2 className="font-serif text-4xl md:text-6xl text-white mb-5 leading-tight">
            Everything You Need to Know About
            <span className="block italic text-amber-300"> The Drapery &amp; Blind Co.</span>
          </h2>
          <div className="gold-rule mx-auto" />
        </div>

        {/* Block grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-px bg-stone-800">
          {BLOCKS.map((block, i) => (
            <div
              key={i}
              className={`reveal reveal-delay-${i + 1} bg-stone-950 p-8 hover:bg-stone-900 transition-colors duration-400 ${
                i === 3 ? "xl:col-span-2" : i === 4 ? "md:col-span-2 xl:col-span-1" : ""
              }`}
            >
              {/* Icon + tag */}
              <div className="flex items-center gap-3 mb-5">
                <div className="w-9 h-9 flex items-center justify-center border border-amber-700/40 rounded-sm bg-amber-900/20 flex-shrink-0">
                  <i className={`${block.icon} text-amber-500 text-base`} />
                </div>
                <span className="text-amber-600/80 text-xs tracking-[0.28em] uppercase font-semibold">
                  {block.tag}
                </span>
              </div>

              {/* Title */}
              <h3 className="font-serif text-xl text-white mb-3 leading-snug">
                {block.title}
              </h3>

              {/* Divider */}
              <div className="w-8 h-px bg-amber-700/50 mb-4" />

              {/* Body */}
              {block.body && (
                <p className="text-stone-400 text-sm leading-relaxed">{block.body}</p>
              )}
              {block.listItems && (
                <ul className="space-y-2">
                  {block.listItems.map((item, j) => (
                    <li key={j} className="flex items-start gap-2.5 text-stone-400 text-sm">
                      <span className="w-4 h-4 flex items-center justify-center flex-shrink-0 mt-0.5">
                        <i className="ri-checkbox-circle-fill text-amber-600 text-sm" />
                      </span>
                      {item}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
